var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ToolingPreviewNoResults',{attrs:{"title":_vm.messages.title,"image-source":require('../../../assets/media/image/tool-reporting/no-results.webp'),"small-image":true,"image-alt":_vm.messages.title}},[_vm._v("\n  "+_vm._s(_vm.messages.description)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }